import {
    SET_MOODBOARD_LIST,
    SET_MOODBOARD_BY_ID,
    UPDATE_SELECTED_MOODBOARD_STATE,
    SET_COLOR_CODES,
    SET_MOODBOARD_FABRICS,
    SET_FAVOURITE_MOODBOARD,
    UNSET_FAVOURITE_MOODBOARD,
    SET_ALL_MATERIAL_CATEGORY,
    SET_ALL_MATERIAL_SUB_CATEGORY,
    SET_FABRIC_SEARCH_FILTER,
    SET_ALL_FILTER_DATA,
    SET_MOODBOARD_FILTER_SELECTED_FIELDS,
    SET_TAG_LIST, UPDATE_MOODBOARD_LIST,
    SET_MOODBOARD_COLOR,
    SET_MOODBOARD_ADDED_IMAGE
} from '../@types/action.types'

export const MoodboardReducer = {
    [SET_MOODBOARD_LIST]: (state, action) => {
        if ( action.merge )
            state.moodboardList = [...state.moodboardList, ...action.payload.data]
        else
            state.moodboardList = action.payload?.data
        state.currentPage = action.payload?.currentPage
        state.totalPages = action.payload?.totalPages
        state.totalElements = action.payload?.totalElements
    },
    [UPDATE_MOODBOARD_LIST]: (state, action) => {
        state.moodboardList = action.payload
        state.totalElements = action.payload.length
    },
    [SET_MOODBOARD_BY_ID]: (state, action) => {
        state.selectedMoodboard = Object.assign({}, action.payload)
    },
    [SET_MOODBOARD_COLOR]: (state, action) => {
        state.selectedMoodboard.colorResponseList = action.payload
    },
    [SET_MOODBOARD_ADDED_IMAGE]: (state, action) => {
        state.selectedMoodboard.productImageList = action.payload
    },
    [UPDATE_SELECTED_MOODBOARD_STATE]: (state, action) => {
        state.selectedMoodboard.name = action.payload?.name
        state.selectedMoodboard.description = action.payload?.description
    },
    [SET_COLOR_CODES]: (state, action) => {
        state.colorCodes = action?.payload
    },
    [SET_MOODBOARD_FABRICS]: (state, action) => {
        state.moodboardFabrics = action?.payload
    },
    [SET_FAVOURITE_MOODBOARD]: (state, action) => {
        let moodboardIndex = state.moodboardList.findIndex(
            (moodboard) => moodboard.id === action.payload
        )
        state.moodboardList[moodboardIndex].isFavorite = true
    },
    [UNSET_FAVOURITE_MOODBOARD]: (state, action) => {
        let moodboardIndex = state.moodboardList.findIndex(
            (moodboard) => moodboard.id === action.payload
        )
        state.moodboardList[moodboardIndex].isFavorite = false
    },
    [SET_ALL_MATERIAL_CATEGORY]: (state, action) => {
        // console.log('MoodboardReducer', action.payload)
        state.allMaterialCategory = action.payload
    },
    [SET_ALL_MATERIAL_SUB_CATEGORY]: (state, action) => {
        // console.log('MoodboardReducer', action.payload)
        state.allMaterialSubCategory = action.payload
    },
    [SET_FABRIC_SEARCH_FILTER]: (state, action) => {
        // console.log('MoodboardReducer', action.payload)
        state.fabricSearchFilters = action.payload
    },
    [SET_ALL_FILTER_DATA]: (state, action) => {
        // console.log('MoodboardReducer', action.payload)
        state.moodboardFilters.allCategory = action.payload[0].value.data
        state.moodboardFilters.allSeason = action.payload[1].value.data
        state.moodboardFilters.allMarket = action.payload[2].value.data
    },
    [SET_MOODBOARD_FILTER_SELECTED_FIELDS]: (state, action) => {
        // console.log('MoodboardReducer', action.payload)
        state.moodboardFilters.selectedCategory =
            action.payload.selectedCategory
        state.moodboardFilters.selectedSeason = action.payload.selectedSeason
        state.moodboardFilters.selectedMarket = action.payload.selectedMarket
        state.moodboardFilters.selectedDate = action.payload.selectedDate
    },
    [SET_TAG_LIST]: (state, action) => {
        // console.log('MoodboardReducer', action.payload)
        state.tagList = action.payload
        // state.tagList = Object.assign({}, action.payload)
    }
}
